import * as React from "react";
import classnames from "classnames";
/* empty css              */
const TextArea = ({
  className,
  disabled,
  maxLength,
  onChange,
  onBlur,
  placeholder,
  name,
  id,
  ...rest
}) => {
  const resolvedId = id || name;
  const handleChange = React.useCallback(
    (e) => {
      !disabled && onChange && onChange(e.currentTarget.value);
    },
    [disabled, onChange]
  );
  const handleBlur = React.useCallback(
    (e) => {
      !disabled && onBlur && onBlur(e.currentTarget.value);
    },
    [disabled, onBlur]
  );
  return /* @__PURE__ */ React.createElement(
    "textarea",
    {
      ...rest,
      name,
      id: resolvedId,
      className: classnames("textarea", className),
      disabled,
      maxLength,
      onChange: handleChange,
      onBlur: handleBlur,
      placeholder
    }
  );
};
export {
  TextArea as default
};
//# sourceMappingURL=TextArea.js.map
